module.exports = __webpack_public_path__ + "img/03.fc3fcb19.png";